// extracted by mini-css-extract-plugin
export var hideEditor = "_jc-2";
export var infoIcon = "_jc-3";
export var label = "_jc-1";
export var labelContainer = "_jc-0";
export var readonlyText = "_jc-4";